import { Vigencia } from '@mobile/models/cardapio/cardapio.model';

const DIAS_ABREVIADOS = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
const DIAS_NOMES = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];

/** 'HH:mm' -> '18h' ou '18h30'. */
function horaCurta(hora: string): string {
  const [h, m] = hora.split(':');
  const horas = String(Number(h));
  return Number(m) ? `${horas}h${m}` : `${horas}h`;
}

function listar(itens: string[]): string {
  return itens.length > 1 ? `${itens.slice(0, -1).join(', ')} e ${itens[itens.length - 1]}` : itens[0] ?? '';
}

/** Dia da semana (0 = domingo) e data 'YYYY-MM-DD' de hoje em São Paulo. */
export function hojeSaoPaulo(agora: Date = new Date()): { diaSemana: number; nome: string; data: string } {
  const partes = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(agora);
  const diaSemana = new Date(`${partes}T12:00:00Z`).getUTCDay();
  return { diaSemana, nome: DIAS_NOMES[diaSemana], data: partes };
}

/** Vale em algum momento de hoje (São Paulo)? Ignora o horário; serve para anunciar "hoje tem...". */
export function vigenteNoDia(vigencia: Vigencia | undefined, agora: Date = new Date()): boolean {
  if (!vigencia) {
    return true;
  }
  const { diaSemana, data } = hojeSaoPaulo(agora);
  if ((vigencia.inicio && data < vigencia.inicio) || (vigencia.fim && data > vigencia.fim)) {
    return false;
  }
  const dias = vigencia.diasSemana ?? [];
  return !dias.length || dias.includes(diaSemana);
}

/** "18h às 23h", "a partir das 18h", "até as 23h" ou '' quando vale o dia todo. */
export function descricaoHorario(vigencia?: Vigencia): string {
  if (vigencia?.horaInicio && vigencia.horaFim) {
    return `${horaCurta(vigencia.horaInicio)} às ${horaCurta(vigencia.horaFim)}`;
  }
  if (vigencia?.horaInicio) {
    return `a partir das ${horaCurta(vigencia.horaInicio)}`;
  }
  if (vigencia?.horaFim) {
    return `até as ${horaCurta(vigencia.horaFim)}`;
  }
  return '';
}

/** Texto curto da validade: "Seg, Qua e Sex · 18h às 23h" ("Todos os dias" quando não restringe o dia). */
export function descricaoVigencia(vigencia?: Vigencia): string {
  if (!vigencia) {
    return 'Todos os dias';
  }
  const dias = [...new Set(vigencia.diasSemana ?? [])].sort((a, b) => a - b);
  const partes: string[] = [dias.length && dias.length < 7 ? listar(dias.map(d => DIAS_ABREVIADOS[d])) : 'Todos os dias'];

  const horario = descricaoHorario(vigencia);
  if (horario) {
    partes.push(horario);
  }
  if (vigencia.fim) {
    const [, mes, dia] = vigencia.fim.split('-');
    partes.push(`até ${dia}/${mes}`);
  }
  return partes.join(' · ');
}
